import script from "./AgregarStockDialogComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./AgregarStockDialogComponent.vue?vue&type=script&setup=true&lang=js"

import "./AgregarStockDialogComponent.vue?vue&type=style&index=0&id=53bba285&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53bba285"]])

export default __exports__